const logo = {
  first: "./images/logo.jfif",
  second: "./images/logo2.jfif",
};

export default logo;
